import { createFileRoute, redirect } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import nookies from "nookies";
import { ErrorElement } from "~/components/ErrorElement";

import { CatatanKasir } from "~/features/kasir";

export const Route = createFileRoute("/_layout/kasir/")({
  beforeLoad: () => {
    const isLogin = nookies.get().token !== undefined;

    if (!isLogin) {
      throw redirect({
        to: "/",
      });
    }
  },

  component: () => (
    <>
      <Helmet>
        <title>Catatan Kasir - Ecobiz</title>
      </Helmet>
      <CatatanKasir />
    </>
  ),
  errorComponent: () => <ErrorElement statusCode="500" />,
  notFoundComponent: () => <ErrorElement statusCode="404" />,
});
